<div class="about-template">
  <div class="section-title">
    <h4 class="h4 pt-2" *ngIf="!descriptionTitle">{{translationScope+'.titles.about' | transloco}}</h4>
    <h4 class="h4 pt-2" *ngIf="descriptionTitle"> {{ descriptionTitle }}</h4>
  </div>
  <ng-container *ngIf="description?.length > 275; else buttonLess">
    <p
      class="paragraph"
      [class.expand-less]="readMoreText"
      [innerHtml]="description"
    >
    </p>

    <a class="about read-more" (click)="readMore()">
      <ng-container *ngIf="readMoreText"
        >{{translationScope+'.read_more' | transloco}} <i class="icon-plus"></i
      ></ng-container>
      <ng-container *ngIf="!readMoreText"
        >{{translationScope+'.read_less' | transloco}} <i class="icon-minus"></i
      ></ng-container>
    </a>
  </ng-container>
  <ng-template #buttonLess>
    <p class="paragraph" [innerHtml]="description">
      <!-- {{ description }} -->
    </p>
  </ng-template>
</div>
